import React from 'react';
import styled, { css } from 'styled-components';

import { colors } from '../constant';
import { numberWithCommas } from '../methods';

const CostsList = ({ project_costs = [], cost_sum = 0 }) => {
    
    if (project_costs.length <= 0) return null;

    return (
        <Root>
            <Label>外部成本</Label>
            <Table>
                { project_costs.map((item, index) => 
                    <TableRow key={index}>
                        <td>{ item.type }</td>
                        <td>{ item.name }</td>
                        <td>${ numberWithCommas(item.cost) }</td>
                    </TableRow>
                )}
                <TableRow sum>
                    <td></td>
                    <td>總計</td>
                    <td>${ numberWithCommas(cost_sum) }</td>
                </TableRow>
            </Table>
        </Root>
    )
}

const Root = styled.div`
    margin-top: 16px;
    padding: 40px 0;
    border-top: 1px solid #E0E0E0;
`

const Label = styled.h3`
    margin: 0;
    padding: 0;
    font-size: 16px;
    font-weight: 700;
    color: ${ colors.label1 };
`

const Table = styled.table`
    margin-top: 16px;
    width: 100%;
`

const TableRow = styled.tr`
    >td {
        padding: 8px 0;
    }

    >td:nth-child(1) {
        color: ${ colors.label2 };
        max-width: 160px;
    }

    >td:nth-child(2) {
        color: ${ colors.label1 };
        font-size: 16px;
        font-weight: 600;
    }

    >td:nth-child(3) {
        color: ${ colors.text };
        font-size: 16px;
        font-weight: 600;
        text-align: right;
    }

    ${({sum}) => sum && css`
        >td {
            padding-top: 12px;
            margin-top: 12px;
        }

        >td:nth-child(2), >td:nth-child(3) {
            border-top: 1px solid #E0E0E0;
        }
    `}
`

export default CostsList
